import type { UseMgoClientQueryOptions } from './useMgoClientQuery.js';
import { useMgoClientQuery } from './useMgoClientQuery.js';

export function useRpcApiVersion(options?: UseMgoClientQueryOptions<'getRpcApiVersion'>) {
	return useMgoClientQuery(
		{
			method: 'getRpcApiVersion',
			params: {},
		},
		options,
	);
}
